/**
 * Return Prime (/apps/return_prime): inject return/exchange policy link below Find Your Order.
 */
(function () {
  var PRIVACY_MARKER = 'data-return-prime-privacy-injected';

  function getExtraConfig() {
    var el = document.getElementById('ReturnPrimeExtraConfig');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function injectPrivacyLink() {
    var app = document.querySelector('.returnprime__app');
    if (!app || app.querySelector('[' + PRIVACY_MARKER + ']')) return;

    var cfg = getExtraConfig();
    if (!cfg || !cfg.privacyUrl) return;

    var btnRow = app.querySelector('.form__field.search__btn');
    if (!btnRow) return;

    var wrap = document.createElement('div');
    wrap.className = 'return-prime-privacy-link-wrap text-center';
    wrap.setAttribute(PRIVACY_MARKER, 'true');

    var a = document.createElement('a');
    a.href = cfg.privacyUrl;
    a.className = 'return-prime-privacy-link link';
    a.textContent = cfg.privacyLabel || 'See our Return & Exchange policy';

    wrap.appendChild(a);
    btnRow.after(wrap);
  }

  function hideEmptyAppPolicyPlaceholder() {
    var app = document.querySelector('.returnprime__app');
    if (!app) return;
    var emptyPolicy = app.querySelector('.policy__text');
    if (emptyPolicy && !emptyPolicy.textContent.trim()) {
      emptyPolicy.setAttribute('hidden', '');
      emptyPolicy.style.display = 'none';
    }
  }

  function run() {
    hideEmptyAppPolicyPlaceholder();
    injectPrivacyLink();
  }

  run();

  var obs = new MutationObserver(function () {
    run();
  });
  obs.observe(document.documentElement, { childList: true, subtree: true });
})();
